<template>
  <el-dialog
    title="入库导入结果"
    :visible.sync="dialogVisible"
    width="30%"
    class="dialog"
  >
    <div style="text-align: center;">导入失败，请点击下载导入结果并检查失败原因，完成修改后重新导入</div>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadImportResult"
          >下载导入结果</el-button
        >
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      downloadId: ""
    };
  },
  methods: {
    openDialog (downloadId) {
      this.downloadId = downloadId;
      this.dialogVisible = true
    },
    closeDialog () {
      this.dialogVisible = false
    },
    // 下载导入结果
    downloadImportResult() {
      this.dialogVisible = false
      let url = `/autoapp-default-server-recovery/api/oldMachineRecovery/downLoadInboundFailInfo/${this.downloadId}`
      let title = '导入失败结果'
      this.global.exportExcel(url, {}, title).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 20px !important;
    // padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/StorageImportResultDialog.vue